export const TRENDS_KEYS = [
    "TEMPERATURE",
    "SET_POINT",
    "ON_OFF",
    "MODE",
    "FAN_SPEED",
    "POWER_METER",
    "GAS_METER",
    "APPARENT_POWER",
    "VOLTAGE",
    "CURRENT",
    "POWER_FACTOR",
    "HUMIDITY",
    "CO2",
    "PM10",
    "PM2_5",
    "VOC",
    "PRESSURE",
    "ELECTRICITY_CONSUMPTION",
    "STANDBY_DEADBAND",
    "BYPASS_TIME",
    "FAN_SPEED_FRACTION",
    "VALVE_DEMAND_FRACTION",
    "WATER_TEMPERATURE",
    "CONSUMPTION_RATE",
    "RUN_HOURS",
    "DEADBAND_SETPOINT",
    "CO2_SETPOINT",
    "PRESSURE_SETPOINT",
    "WATER_SETPOINT"
];

// used to put together the right kind of trend chart
export const CATEGORICAL = [
    "FAN_SPEED",
    "MODE",
    "ON_OFF"
];

export const KEY_TO_TEXT = {
    TEMPERATURE: "Temperature",
    SET_POINT: "Set point",
    ON_OFF: "On/off",
    MODE: "Mode",
    FAN_SPEED: "Fan speed",
    POWER_METER: "Electricity meter",
    GAS_METER: "Gas meter",
    APPARENT_POWER: "Apparent power",
    VOLTAGE: "Voltage",
    CURRENT: "Current",
    POWER_FACTOR: "Power factor",
    HUMIDITY: "Humidity",
    CO2: "CO2",
    PM10: "PM 10",
    PM2_5: "PM 2.5",
    VOC: "VOC",
    PRESSURE: "Pressure",
    ELECTRICITY_CONSUMPTION: "Electricity consumption",
    STANDBY_DEADBAND: "Standby deadband",
    BYPASS_TIME: "Bypass time",
    FAN_SPEED_FRACTION: "Fan speed fraction",
    VALVE_DEMAND_FRACTION: "Valve demand fraction",
    WATER_TEMPERATURE: "Water temperature",
    CONSUMPTION_RATE: "Consumption rate",
    RUN_HOURS: "Run hours",
    DEADBAND_SETPOINT: "Deadband setpoint",
    CO2_SETPOINT: "CO2 setpoint",
    PRESSURE_SETPOINT: "Pressure setpoint",
    WATER_SETPOINT: "Water setpoint"
};

export const KEY_TO_UNIT = {
    TEMPERATURE: "°C",
    SET_POINT: "°C",
    POWER_METER: "kW",
    GAS_METER: "kW",
    APPARENT_POWER: "kVA",
    VOLTAGE: "V",
    CURRENT: "A",
    HUMIDITY: "%",
    CO2: "ppm",
    PM10: "µg/m³",
    PM2_5: "µg/m³",
    VOC: "ppb",
    PRESSURE: "hPa",
    WATER_TEMPERATURE: "°C",
    CONSUMPTION_RATE: "BTU/ hr",
    RUN_HOURS: "h",
    DEADBAND_SETPOINT: "°C",
    CO2_SETPOINT: "ppm",
    PRESSURE_SETPOINT: "bar",
    WATER_SETPOINT: "°C",
};

export const ALLOWED_INPUT_CATEGORICAL_VALUES = {
    ON_OFF: ["ON", "OFF"],
    MODE: [
        "AUTO",
        "HEAT",
        "DRY",
        "FAN",
        "COOL",
        "AUTO_HEAT",
        "AUTO_COOL",
        "AUTO_FAN",
        "AUTO_DRY",
        "SETBACK",
        "SETBACK_HEAT",
        "SETBACK_COOL",
    ],
    FAN_SPEED: ["AUTO", "1", "2", "3", "4", "5", "6", "7"]
};

export const OCCUPANCY_POINT_KEYS = [
    "OCCUPANCY_COUNT",
    "OCCUPANCY_READING",
    "MOTION_READING",
    "OCCUPIED",
];

export const OCCUPANCY_KEY_TO_TEXT = {
    OCCUPANCY_COUNT: "Occupancy count",
    OCCUPANCY_READING: "Occupancy event",
    MOTION_READING: "Motion event",
    OCCUPIED: "Occupied/not occupied",
};

export const ENVIRONMENTAL_KEY_TO_TEXT = {
    OUTSIDE_TEMP: "Outside temperature",
    DIRECT_IRRADIANCE: "Direct irradiance",
};

export const ENVIRONMENTAL_KEY_TO_UNIT = {
    OUTSIDE_TEMP: "°C",
    DIRECT_IRRADIANCE: "W/m²",
};
